import { pushGA4CustomEvent } from "@ocm/services/analytics4Tracking";
import pushDataLayer from "@ocm/services/dataLayer";

export const tr_searchEvent = (payload: Record<string, string>) => {
	pushGA4CustomEvent("search", payload);
};

export const tr_searchClick = (target: "Icon" | "Field") => {
	pushDataLayer({
		event: "GAevent",
		event_category: "S_1stlevel",
		event_action: `S_${target} Desktop Search`,
	});
};

export const tr_searchDepartmentToggle = (payload: Record<string, string | undefined>) => {
	pushGA4CustomEvent("search", payload);
};
